import * as React from 'react';
import TransferList from '../../../../common/transfer-list';
import Administrator from '../../../../../models/administrator';
import Client from '../../../../../models/client';
import { useAdministrators } from '../../../../../hooks/useAdministrators';
import _ from 'lodash';
import { CircularProgress } from '@material-ui/core';
import * as styles from '../client-admin.module.scss';

interface Props {
  client: Client;
  // FormikHelper.setFieldValue
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

const AdministratorTransfer = ({ client, setFieldValue }: Props) => {
  const administratorQuery = useAdministrators();
  const [unassignedAdmins, setUnassignedAdmins] = React.useState<Administrator[]>([]);
  const [assignedAdmins, setAssignedAdmins] = React.useState<Administrator[]>(client.assignedAdministrators);

  React.useEffect(() => {
    if (administratorQuery.data && client.assignedAdministrators.length == 0) {
      setUnassignedAdmins(administratorQuery.data);
    } else if (administratorQuery.data && client.assignedAdministrators.length > 0) {
      setUnassignedAdmins(_.differenceBy(administratorQuery.data, [...client.assignedAdministrators], 'id'));
    }
  }, [administratorQuery.data, client]);

  return (
    <React.Fragment>
      <h2 className={styles.formSectionHeading}>
        Administrators{' '}
        {(administratorQuery.isLoading || administratorQuery.isFetching) && <CircularProgress size="1em" />}
      </h2>
      <TransferList
        idField="id"
        labelField="fullName"
        left={unassignedAdmins}
        right={assignedAdmins}
        setLeft={setUnassignedAdmins}
        setRight={setAssignedAdmins}
        setFieldValue={setFieldValue}
        setField="assignedAdministrators"
      />
    </React.Fragment>
  );
};

export default AdministratorTransfer;
